export const visit = (vm, at) => {
vm(require("./unlock-calling/en.lyaml"));
vm(require("./alert-store/en.lyaml"));
vm(require("./settings-save-bar/en.lyaml"));
vm(require("./error-handling/en.lyaml"));
vm(require("./calls-index-page/en.lyaml"));
vm(require("./call-highlight-card/en.lyaml"));
vm(require("./settings-usage/en.lyaml"));
vm(require("./tracked-terms/en.lyaml"));
vm(require("./phone-number-table/en.lyaml"));
vm(require("./phone-number-verification/en.lyaml"));
vm(require("./forwarding-number-guidance/en.lyaml"));
vm(require("./address-validation/en.lyaml"));
vm(require("./outbound-number-table/en.lyaml"));
vm(require("SharedI18nStrings/lang/countryCodes/en.lyaml"));
at({ "en": { "calling-orchestration-shared-library": { "key": "value" } } });
};